import React from 'react';
import ConfirmWithCommentDialog, { ConfirmWithCommentPayload } from './ConfirmWithCommentDialog';
import { HelpBox } from '../help-boxes';
import * as Yup from 'yup';

type Props = {
  isOpened: boolean;
  onClose(payload: ConfirmWithCommentPayload | null): void;
};

const validationSchema = Yup.object({
  commentText: Yup.string().required('Required').max(2000, 'Maximum 2000 characters allowed'),
});

const LicenseeAdminReviewDialog: React.FC<Props> = ({ isOpened, onClose }) => {
  return (
    <ConfirmWithCommentDialog
      header="Licensee review"
      help={
        <HelpBox>
          <span>
            Please review the documents and information provided by the EPD Owner. <br />
            <br /> Once your review is complete, kindly add your comments indicating your findings, including any potential
            deviations, non-conformities, or confirmation that everything is in order, so that the Secretariat can proceed
            accordingly with the EPD publication.
          </span>
        </HelpBox>
      }
      inputLabelText="Licensee Admin comment"
      primaryButtonText="Send"
      isOpened={isOpened}
      onClose={onClose}
      isCommentRequired
      closable={false}
      validationSchema={validationSchema}
      commentMaxRows={6}
    />
  );
};

export default LicenseeAdminReviewDialog;
